import { type ReactNode } from "react";
import classNames from "classnames";

export const ParamsGrid = ({ params, noColumnFlex }: ParamsGridProps) => {
  const columnCls = classNames("scha__params-grid__column", {
    "scha__params-grid__column--no-flex": noColumnFlex,
  });
  return (
    <div className="scha__params-grid">
      {params.map((column, index) => (
        <div className={columnCls} key={`column-${index}`}>
          {column.map((row, i) => (
            <ParamComponent label={row.label} value={row.value} key={`param-${i}`} />
          ))}
        </div>
      ))}
    </div>
  );
};

export const ParamComponent = (props: { label: ReactNode; value: ReactNode | ReactNode[] }) => (
  <div className={classNames("scha__param-comp")}>
    <div className="scha__param-comp__label">{props.label}</div>
    {Array.isArray(props.value) && props.value.map((val) => <div className="scha__param-comp__value">{val}</div>)}
    {!Array.isArray(props.value) && <div className="scha__param-comp__value">{props.value}</div>}
  </div>
);

export interface ParamsGridProps {
  params: ParamOptions[][];
  noColumnFlex?: boolean;
}

interface ParamOptions {
  label: ReactNode;
  value: ReactNode;
}
